import { EmptyState, Space } from '@procurify/ui'

import { PaginationControls } from '@webapp/core/components/PaginationControls'
import { AuditLogListStyled } from './styles/AuditLogListStyled'
import { useAuditLogListPresenter } from './useAuditLogListPresenter'
import {
  AuditLogRecord,
  AuditLogRecordLoader,
} from '../../views/AuditLogRecord'

export interface IAuditLogListPresenterProps {
  contentTypeId: number
  /** Omitted → module-wide log for the content type (BHV-030) */
  objectId?: string
  showPageLimit?: boolean
  ['aria-label']?: string
}

export const AuditLogListPresenter = ({
  contentTypeId,
  objectId,
  showPageLimit = true,
  'aria-label': ariaLabel = 'Audit log',
}: IAuditLogListPresenterProps) => {
  const {
    data: { auditLog },
    state: { showLoader, showAuditLog },
  } = useAuditLogListPresenter({
    contentTypeId,
    objectId,
  })

  return (
    <div aria-label={ariaLabel}>
      {showLoader && (
        <AuditLogListStyled>
          <AuditLogRecordLoader />
          <AuditLogRecordLoader />
          <AuditLogRecordLoader />
        </AuditLogListStyled>
      )}

      {!showLoader && (
        <PaginationControls id='audit-log'>
          <Space size='large'>
            {showAuditLog ? (
              <AuditLogListStyled>
                {auditLog.map((auditLogRecord, index) => (
                  <AuditLogRecord
                    key={`audit-log-${index}`}
                    status={auditLogRecord.status}
                    title={auditLogRecord.title}
                    userName={auditLogRecord.changedBy.fullName}
                    changedOn={auditLogRecord.changedOn}
                    changedFields={auditLogRecord.changedFields}
                    delegateeUserName={auditLogRecord.delegatee?.fullName}
                  />
                ))}
              </AuditLogListStyled>
            ) : (
              <EmptyState context='history' />
            )}
            <PaginationControls id='audit-log'>
              <Space direction='horizontal' justify='space-between'>
                {showPageLimit && <PaginationControls.PageLimit />}
                <PaginationControls.Page />
              </Space>
            </PaginationControls>
          </Space>
        </PaginationControls>
      )}
    </div>
  )
}
